<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; line-height: 50px; font-size: 20px; font-weight: bold; text-align: center; background-color: #E8E8E8;">
      {{item.type.toUpperCase()}} <span v-if="item.finalised === true">[완료]</span>
    </div>
    <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
      <div class="container">
        <div class="row">
          <div class="col-6 text-left">
            To:
            <select v-model="item.customerId" class="form-control" @change="onCustomerChanged">
              <option value="0">고객선택</option>
              <option v-for="c in customers" :value="c.id">{{c.title}}</option>
            </select>
            <input v-model="item.invoiceTo" class="form-control"/>
            <textarea v-model="item.invoiceAddress" class="form-control" rows="5"/>
            <input v-model="item.invoiceToTel" class="form-control" placeholder="Tel"/>
            <input v-model="item.invoiceToEmail" class="form-control" placeholder="Email"/>
          </div>
          <div class="col-3 text-left">

            <span v-if="item.type === 'quotation'">
              Quotation Date
            </span>
            <span v-else>
              Invoice Date
            </span>
            <input type="date" v-model="item.invoiceDate" class="form-control"/>

            S/ Mode
            <select v-model="item.shippingMode" class="form-control">
              <option value="">Select</option>
              <option v-for="mode in shippingModes" :value="mode">{{mode}}</option>
            </select>
          </div>
          <div class="col-3 text-left">
            <template v-if="item.type === 'quotation'">
            Ref No
            <input v-model="item.invoiceNumber" class="form-control" disabled/>
            </template>
            <template v-else-if="item.type === 'invoice'">
            Invoice No
            <input v-model="item.invoiceNumber" class="form-control" disabled/>
            </template>
            <span v-if="item.type === 'quotation'">
              Valid to
            </span>
            <span v-else>
              Due Date
            </span>
            <input type="date" v-model="item.dueDate" class="form-control"/>
          </div>
        </div>
        <hr/>


        <div class="row">
          <div class="col-12">
            <table class="table">
              <tr>
                <td>Description</td>
                <td><input v-model="item.description" class="form-control"/></td>
                <template v-if="item.type === 'invoice'">
                  <td>Shipper</td>
                  <td><input v-model="item.shipper" class="form-control"/></td>
                </template>
                <template v-else>
                  <td>Expatriates Name</td>
                  <td><input v-model="item.expatriatesName" class="form-control"/></td>
                </template>
              </tr>

              <tr>
                <td>
                  <label>B/L(Ref) No</label>
                  <br/>
                  <label v-if="item.type === 'invoice'">Cntr No</label>
                </td>
                <td>
                  <input v-model="item.blNo" class="form-control"/>
                  <input v-if="item.type === 'invoice'" v-model="item.containerNumber" class="form-control"/>
                </td>
                <template v-if="item.type === 'invoice'">
                  <td>Consignee</td>
                  <td><input v-model="item.consignee" class="form-control"/></td>
                </template>
                <template v-else>
                  <td>Packing Date</td>
                  <td><input type="date" v-model="item.packingDate" class="form-control"/></td>
                </template>
              </tr>

              <tr>
                <td>POL</td>
                <td><input v-model="item.pol" class="form-control"/></td>
                <template v-if="item.type === 'invoice'">
                  <td><label style="height: 20px; line-height: 20px;">ETD</label>
                    <br/>
                    <label style="height: 20px; line-height: 20px;">ETA</label>
                  </td>
                  <td>
                    <input type="date" v-model="item.etd" class="form-control"/>
                    <input type="date" v-model="item.eta" class="form-control"/>
                  </td>
                </template>
                <template v-else>
                  <td>Delivery Date</td>
                  <td><input type="date" v-model="item.deliveryDate" class="form-control"/></td>
                </template>
              </tr>

              <tr>
                <td>POD</td>
                <td><input v-model="item.pod" class="form-control"/></td>
                <td>Volume(Cnt'r Size)</td>
                <td><input v-model="item.volume" class="form-control"/></td>
              </tr>

              <tr>
                <td>Vessel/Flight</td>
                <td><input v-model="item.vessel" class="form-control"/></td>
                <td>Delivery Point</td>
                <td><input v-model="item.deliveryPoint" class="form-control"/></td>
              </tr>

              <tr>
                <td>CBM</td>
                <td>
                  <input class="form-control text-right" v-model="item.cbmFloat" type="number"/>
<!--                  <select class="form-control" v-model="item.cbm">-->
<!--                    <option v-for="(i, index) in 71" :value="index">{{index}} CBM</option>-->
<!--                  </select>-->
                </td>
                <td>KG</td>
                <td><input type="number" v-model="item.kg" class="form-control"/></td>
              </tr>

              <tr>
                <td></td><td></td>
                <td>QTY</td>
                <td><input type="number" v-model="item.qty" class="form-control"/></td>
              </tr>
              <tr>
                <td>Residence Address</td>
                <td colspan="3">
                  <input v-model="item.residenceAddress" class="form-control"/>
                </td>
              </tr>


            </table>

          </div>
        </div>

        <hr/>


        <div class="row" v-if="item.type !== 'credit'">
          <div class="col-12">
            <table class="table">
              <tr>
                <th>Freight & Charge</th>
                <th>Currency</th>
                <th>Vat Rate</th>
                <th>Amount</th>
                <th>Vat AMT</th>
                <th>Total</th>
                <th></th>
              </tr>
              <tbody>
                <tr v-for="(p, pi) in item.list">
                  <td><input v-model="p.title" class="form-control"/></td>
                  <td>
                    <select v-model="p.currency" class="form-control">
                      <option value="">Select</option>
                      <option value="GBP">GBP</option>
                      <option value="USD">USD</option>
                      <option value="KRW">KRW</option>
                    </select>
                  </td>
                  <td>
                    <input type="number" v-model="p.vatRateFloat" class="form-control" @change="onInvoiceItemChanged"/>
                  </td>
                  <td>
                    <input type="number" v-model="p.amountFloat" class="form-control" @change="onInvoiceItemChanged"/>
                  </td>
                  <td>
                    <input type="number" v-model="p.vatFloat" class="form-control" @change="onInvoiceItemChanged"/>
                  </td>
                  <td>
                    <label class="form-control">{{(p.total/100.0).toFixed(2)}}</label>
                  </td>
                  <td>
                    <span @click="deleteInvoiceItem(pi)"><i class="fas fa-trash"></i></span>
                  </td>
                </tr>
              </tbody>
              <tbody>
              <tr>
                <td colspan="7" class="text-left"><button class="btn btn-success" @click="addInvoiceItem"><i class="fas fa-plus"></i> 추가하기</button></td>
              </tr>
              </tbody>
              <tbody>
              <tr>
                <th>
                  TOTAL
                </th>
                <th>
                  <select class="form-control" v-model="item.currency">
                    <option value="">Select</option>
                    <option value="GBP">GBP</option>
                    <option value="USD">USD</option>
                    <option value="KRW">KRW</option>
                  </select>
                </th>
                <th/>
                <th>{{(item.amount/100.0).toFixed(2)}}</th>
                <th>{{(item.vat/100.0).toFixed(2)}}</th>
                <th>{{(item.total/100.0).toFixed(2)}}</th>
                <th/>
              </tr>
              </tbody>
<!--              <tbody>-->
<!--              <tr>-->
<!--                <th>-->

<!--                </th>-->
<!--                <th>-->

<!--                </th>-->
<!--                <th/>-->
<!--                <th></th>-->
<!--                <th>PAYMENT</th>-->
<!--                <th><input v-if="item.paidFloat !== undefined" v-model="item.paidFloat" class="form-control" @change="setPayment"/></th>-->
<!--                <th/>-->
<!--              </tr>-->
<!--              </tbody>-->
            </table>
          </div>
        </div>


        <hr/>
        <div class="row">
          <div class="col-12">
            <textarea v-model="item.remarks" class="form-control" rows="5"/>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 50px; line-height: 50px; display: flex; background-color: #E8E8E8; ">
      <div style="width: 25%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: left;">
        <button class="btn btn-dark" v-on:click="closeItem">Close</button>

      </div>
      <div style="width: 25%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: center;">
        <button class="btn btn-danger" v-on:click="deleteInvoice">삭제</button>
      </div>
      <div style="width: 70%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: right;">
        <button v-if="item.type === 'quotation'" class="btn btn-danger" v-on:click="createInvoiceFrom">인보이스 생성</button>
        <button class="btn btn-danger" v-if="item.finalised === false" v-on:click="completeItem">완료처리</button>
        <button class="btn btn-success" v-if="item.url !== null && item.url.length > 0" v-on:click="openPDF">PDF 보기</button>
        <button class="btn btn-primary" v-on:click="getPDF">PDF 다시생성</button>

        <button class="btn btn-success" v-on:click="saveItem">SAVE</button>
      </div>


    </div>

    <template v-if="pdfItem !== false">
      <transition name="slideup">
        <pdf-viewer
          :item="pdfItem"
          :on-close="closePdfViewer">

        </pdf-viewer>
      </transition>
    </template>
  </div>
</template>

<script>
  import DatePicker from "vue2-datepicker";
  import {getShippingMode} from "../api/request";
  import {createNewInvoiceItem, deleteInvoiceItem, getInvoicePDF, updateInvoice, deleteInvoice} from "../api/invoices";
  import {generateOrderNumber, millisToDate, showDialog} from "../api/utils";

  import PdfViewer from "./PdfViewer";
  export default {
    name: "InvoiceView",
    data() {
      return {
        type:'',
        shippingModes:getShippingMode(),
        pdfItem: false,
      }
    },

    props: {
      request: {
        type:Object,
        default: function() {return null;}
      },
      item: {
        type:Object,
        default: function(){return null;}
      },
      onUpdated: {
        type:Function,
        default:null,
      },
      onClose: {
        type: Function,
        default:null,
      },
      onDeleted: {
        type: Function,
        default:null,
      },
      createInvoice: {
        type: Function,
        default: null,
      },
      customers: {
        type: Array,
        default:() => [],
      }
    },
    components: {
      DatePicker,
      PdfViewer
    },
    created() {
    },
    mounted() {
      this.item.paidFloat =parseFloat((this.item.paid/100.0).toFixed(2));
      console.log("customers");
      console.log(this.customers);

      console.log("invoice");
      console.log(this.item);
    },
    methods: {

      // onClose: function() {
      //   if(this.onClose !== null) {
      //     this.onClose();
      //   }
      // },
      dummy: function () {

      },
      createInvoiceFrom: function() {
        let self = this;

        // self.onInvoiceItemChanged();

        this.item.cbm = Math.round(parseFloat(this.item.cbmFloat)*100);
        updateInvoice(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.createInvoice !== null) {
              self.createInvoice(data.item);
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })

      },
      closeItem: function() {
        if(this.onClose !== null) {
          this.onClose();
        }
      },
      setPayment: function() {
        this.item.paid = parseInt(parseFloat(this.item.paidFloat)*100);
        console.log("payment set to " + this.item.paid);
      },
      completeItem: function() {
        let self = this;
        this.$modal.show('dialog', {
          //title: '로그아웃',
          text: '현재 인보이스를 완료 처리 하시겠습니까?',
          buttons: [
            {
              title: '아니요',
              handler: () => {
                self.$modal.hide('dialog');

              }
            },
            {
              title: '완료처리하기',
              handler: () => {
                self.$modal.hide('dialog');

                self.completeItemConfirmed();
              }
            },

          ]

        });
      },
      completeItemConfirmed: function() {
        this.item.finalised = true;
        this.item.paid = this.item.total;
        this.saveItem();
      },
      onCustomerChanged: function() {
        this.item.invoiceTo = '';
        this.item.invoiceAddress = '';
        this.item.email = '';
        this.item.tel = '';

        for(let i = 0 ; i < this.customers.length ; i++) {
          if(this.customers[i].id === this.item.customerId) {
            this.item.invoiceTo = this.customers[i].title;
            this.item.invoiceAddress = this.customers[i].address;
            this.item.tel = this.customers[i].contact;
            this.item.email = this.customers[i].email;
          }
        }
        // this.saveItem();
      },
      saveItem: function() {
        let self = this;
        this.item.cbm = Number(parseFloat(this.item.cbmFloat)*100);
        updateInvoice(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      },
      addInvoiceItem: function() {
        let newItem = createNewInvoiceItem(this.item.id, this.item.requestId);
        this.item.list.push(newItem);
      },
      onInvoiceItemChanged: function() {
        this.item.vat = 0;
        this.item.amount = 0;
        this.item.total = 0;
        for(let i = 0 ; i < this.item.list.length ; i++) {
          console.log(this.item.list[i]);
          this.item.list[i].vatRate = parseInt((parseFloat(this.item.list[i].vatRateFloat) * 100));
          this.item.list[i].amount = parseInt((parseFloat(this.item.list[i].amountFloat) * 100));
          this.item.list[i].vatFloat = parseFloat(this.item.list[i].amountFloat) * parseFloat(this.item.list[i].vatRateFloat) / 100;
          this.item.list[i].vat = parseInt((parseFloat(this.item.list[i].vatFloat) * 100));
          this.item.list[i].totalFloat = parseFloat(this.item.list[i].amountFloat) + parseFloat(this.item.list[i].vatFloat);
          this.item.list[i].total = parseInt((parseFloat(this.item.list[i].totalFloat) * 100));
          this.item.vat += this.item.list[i].vat;
          this.item.amount += this.item.list[i].amount;
          this.item.total += this.item.list[i].total;
          console.log(this.item.list[i]);
        }

      },
      deleteInvoiceItem: function(index) {
        console.log(this.item);
        if(this.item.list[index].id === 0) {
          this.item.list.splice(index, 1);
          return;
        }

        let self = this;
        deleteInvoiceItem(this.item.list[index].id)
        .then(function(data) {
          if(data.success === true) {
            self.item.list.splice(index, 1);
            self.onInvoiceItemChanged();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })


      },
      deleteInvoice: function() {
        let self = this;
        this.$modal.show('dialog', {
          //title: '로그아웃',
          text: '현재 인보이스를 삭제하시겠습니까?',
          buttons: [
            {
              title: '아니요',
              handler: () => {
                self.$modal.hide('dialog');

              }
            },
            {
              title: '지우기',
              handler: () => {
                self.$modal.hide('dialog');

                self.deleteInvoiceConfirmed();
              }
            },

          ]

        });
      },
      deleteInvoiceConfirmed: function() {
        let self = this;
        deleteInvoice(this.item.id)
          .then(function(data) {
            if(data.success === true) {
              if(self.onDeleted !== null) {
                self.onDeleted(data.item);
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
      openPDF: function() {
        console.log("open pdf");
        console.log(this.request);

        let date = millisToDate(new Date(), '-');

        let emailForm = {
          to: this.item.invoiceToEmail,
          subject:this.item.type.toUpperCase() + ' ' + this.item.shippingMode + ' ' + this.request.requester + ' ' + date,
          body: '안녕하세요 UKO Shipping입니다.\n',
          documents:[{
            title:this.item.type.toUpperCase() + '-' + this.item.shippingMode + '-' + this.request.requester + '-' + (this.item.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
            url:this.item.url,
          }]
        }
        this.$data.pdfItem = {
          url: this.item.url,
          title: this.item.type.toUpperCase() + ' ' + this.request.requester + ' ' + this.request.hbNo + ' ' + ' #' + this.item.id,
          emailForm: emailForm,
        }
      },
      getPDF: function() {
        // Save first
        let self = this;
        updateInvoice(this.item)
        .then(function(data) {
          if(data.success === true) {
            self.generatePDF();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response  +')';
          }
          showDialog(msg, "ERROR");
        })
      },
      generatePDF: function() {
        // let self = this;
        // const FileDownload = require('js-file-download');
        // let filename = 'unknown.pdf';
        // if(self.item.type === 'quotation') {
        //   filename = self.item.invoiceNumber + "-" + self.item.pol + '-' + self.item.pod + '-' + self.item.expatriatesName + '-' + new Date().getTime() + '.pdf';
        // } else if(self.item.type === 'invoice') {
        //   filename = 'INVOICE-' + self.item.shipper + '-' + self.item.invoiceNumber  + '-' + self.item.invoiceDate + '-' + new Date().getTime() + '.pdf';
        // }
        let self = this;
        getInvoicePDF(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.item.url = data.item.url;

            let date = millisToDate(new Date(), '-');

            let emailForm = {
              to: self.item.invoiceToEmail,
              subject:self.item.type.toUpperCase() + ' ' + self.item.shippingMode + ' ' + self.request.requester + ' ' + date,
              body: '안녕하세요 UKO Shipping입니다.\n',
              documents:[{
                title:self.item.type.toUpperCase() + '-' + self.item.shippingMode + '-' + self.request.requester + '-' + (self.item.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
                url:self.item.url,
              }]
            }
            self.$data.pdfItem = {
              url: data.item.url,
              title: self.item.type.toUpperCase() + ' ' + self.request.requester + ' ' + self.request.hbNo + ' #' + self.item.id,
              emailForm: emailForm,
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response  +')';
          }
          showDialog(msg, "ERROR");
        })
      },
      closePdfViewer: function() {
        this.$data.pdfItem = false;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/InvoiceView.vue